import Button from '../ui/Button'; // Make sure to import Button component properly

const getPlatformBadge = (platform?: string) => {
    if (platform === "telegram") {
        return { label: "Telegram", className: "bg-sky-500/15 text-sky-300 border-sky-500/40" };
    }
    if (platform === "discord") {
        return { label: "Discord", className: "bg-indigo-500/15 text-indigo-300 border-indigo-500/40" };
    }
    if (platform === "slack") {
        return { label: "Slack", className: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40" };
    }
    return null;
};

const PlanCard = ({
    plan,
    handleSubscribeClick,
    couponCode,
    platform,
    pricingPreview,
    actionLabel = "Subscribe",
    showPricing = true,
    isSubmitting = false,
}) => {
    const effectivePrice = plan.discounted_price ?? plan.markup_price;
    const badge = getPlatformBadge(platform);
    const previewFinalAmount = pricingPreview?.finalAmount;
    const previewDiscountAmount = pricingPreview?.discountAmount;
    const hasPreview = typeof previewFinalAmount === "number" && previewFinalAmount < effectivePrice;

    return (
        <div
            key={plan._id}
            className="border border-dark-tertiary rounded-lg p-4 space-y-3 hover:border-golden-accent transition-colors"
        >
            <h3 className="text-lg font-semibold text-text-primary">{plan.name}</h3>

            {badge && (
                <span className={`inline-flex items-center text-xs px-2 py-0.5 rounded-full border ${badge.className}`}>
                    {badge.label}
                </span>
            )}

            {showPricing && plan.markup_price != null && plan.markup_price > plan.discounted_price && (
                <span>
                    Price:{" "}
                    <span
                        className={`font-medium ${plan.discounted_price !== null
                            ? "line-through text-text-disabled"
                            : "text-functional-success"
                            }`}
                    >
                        ₹{plan.markup_price}
                    </span>
                </span>
            )}

            {showPricing && effectivePrice !== null && effectivePrice !== undefined && (
                <div>
                    {hasPreview ? (
                        <>
                            <p className="text-sm text-text-disabled line-through">₹{effectivePrice}</p>
                            <p className="text-xl font-bold text-functional-success">
                                ₹{previewFinalAmount}
                            </p>
                        </>
                    ) : (
                        <p className="text-xl font-bold text-functional-success">
                            ₹{effectivePrice}
                        </p>
                    )}
                </div>
            )}

            {showPricing && couponCode && (
                <p className="text-xs text-golden-accent">
                    Coupon <strong>{couponCode}</strong> will be validated at checkout.
                </p>
            )}
            {showPricing && hasPreview && (
                <p className="text-xs text-functional-success">
                    Discount applied: -₹{previewDiscountAmount}
                </p>
            )}
            <p className="text-sm text-text-secondary">{plan.validity_days} Days Validity</p>

            {plan.description && (
                <p className="text-xs text-text-secondary break-words whitespace-pre-line">
                    {plan.description}
                </p>
            )}

            <Button
                onClick={() => handleSubscribeClick(plan)}
                variant="primary"
                size="sm"
                className="w-full mt-4"
                disabled={isSubmitting}
                isLoading={isSubmitting}
            >
                {isSubmitting ? "Processing…" : actionLabel}
            </Button>
        </div>
    );
};

export default PlanCard;
